<template>
  <Navbar bgimage="Logo_Digiasia_Color.png" />
  <CareerMain />
  <Footer />
  <Copyright />
</template>

<script>
import CareerMain from "@/components/portal/CareerMain.vue";
import Footer from "@/components/portal/PageFooterSecond.vue";
import Copyright from "@/components/portal/PageCopyright.vue";
import Navbar from "@/components/portal/Navbar.vue";

export default {
  name: "OurValue",
  components: {
    CareerMain,
    Footer,
    Copyright,
    Navbar,
  },
};
</script>
